import { actionCreator, ActionReturnType, Loading, loadingFailed, loadingFinished, loadingIsLoading, loadingNotStarted } from "@itk/typescript-utils";
import { Model_AttributeDetailsGet, Model_ProjectGet } from "src/backend/openapi/v1";

export enum Action {
  GetProjectsRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSREQUEST",
  GetProjectsSuccess = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSSUCCESS",
  GetProjectsFail = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSFAIL",
  GetProjectsAttributesRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSATTRIBUTESREQUEST",
  GetProjectsAttributesSuccess = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSATTRIBUTESSUCCESS",
  GetProjectsAttributesFail = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:GETPROJECTSATTRIBUTESFAIL",
  DeleteProjectRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:DELETEPROJECTREQUEST",
  SetShouldReload = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:SETSHOULDRELOAD",
  Clear = "@@ITK:SRC:PAGES:PROJECT-LIST:PROJECT-LIST-STORE.TS:ACTION:CLEAR"
}

type projectListState = {
  projectListState: Loading<Model_ProjectGet[]>;
  projectsAttributes: Loading<Model_AttributeDetailsGet[]>;
  shouldReload: boolean;
};

const initialState: projectListState = {
  projectListState: loadingNotStarted,
  projectsAttributes: loadingNotStarted,
  shouldReload: false
};

export const projectListActions = {
  // customerId is attached by the header interceptor, no longer forwarded via the payload
  getProjectsRequest: () => actionCreator(Action.GetProjectsRequest),
  getProjectsSuccess: (data: Model_ProjectGet[]) => actionCreator(Action.GetProjectsSuccess, { data }),
  getProjectsFail: () => actionCreator(Action.GetProjectsFail),
  getProjectsAttributesRequest: () => actionCreator(Action.GetProjectsAttributesRequest),
  getProjectsAttributesSuccess: (data: Model_AttributeDetailsGet[]) => actionCreator(Action.GetProjectsAttributesSuccess, { data }),
  getProjectsAttributesFail: () => actionCreator(Action.GetProjectsAttributesFail),
  deleteProjectRequest: (projectId: string) => actionCreator(Action.DeleteProjectRequest, { projectId }),
  setShouldReload: (shouldReload: boolean) => actionCreator(Action.SetShouldReload, { shouldReload }),

  clear: () => actionCreator(Action.Clear)
};

export const projectListReducer = (state = initialState, action: ActionReturnType<typeof projectListActions>): projectListState => {
  switch (action.type) {
    case Action.GetProjectsRequest:
      return { ...state, projectListState: loadingIsLoading };
    case Action.GetProjectsSuccess:
      return { ...state, projectListState: loadingFinished(action.payload.data) };
    case Action.GetProjectsFail:
      return { ...state, projectListState: loadingFailed };

    case Action.GetProjectsAttributesRequest:
      return { ...state, projectsAttributes: loadingIsLoading };
    case Action.GetProjectsAttributesSuccess:
      return { ...state, projectsAttributes: loadingFinished(action.payload.data) };
    case Action.GetProjectsAttributesFail:
      return { ...state, projectsAttributes: loadingFailed };

    case Action.SetShouldReload:
      return { ...state, shouldReload: action.payload.shouldReload };
    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
